<template>
  <div class="vld-parent">
    <loading 
      :active.sync="this.loadingStatus"
      :can-cancel="false"
      :is-full-page="fullPage"
      color="darkbule"
      loader="Bars"
    ></loading>
  </div>
</template>
 
<script>
import "vue-loading-overlay/dist/vue-loading.css";
import Loading from "vue-loading-overlay";
export default {
  data() {
    return {
      fullPage: true,
    };
  },
  components: {
    Loading
  },
  props:{
      loadingStatus:Boolean
  },
};
</script> 